import { Item } from './Item';
import { Vector3 } from 'three';
/**
 * Camera properties interface
 * 
 * @property position - The position of the camera
 * @property lookAt - The point the camera is looking at
 */
export interface CameraProperties {
  position: Vector3;
  lookAt: Vector3;
}

/**
 * Camera fields
 */
export const CameraFields = [
  {
    key: 'properties.position',
    type: 'vector3',
    label: 'Position',
  },
  {
    key: 'properties.lookAt',
    type: 'vector3',
    label: 'Look At',
  },
];

/**
 * Camera item interface 
 * 
 * @property type - The type of item
 * @property properties - The properties of the camera
 */
export type Camera = Item<CameraProperties>; 